import { useEffect, useState } from "react";
import api from "../utils/api";

/**
 * Fetches the dynamic data behind the shared navigation registry:
 * service desks (for the SERVICE DESKS section) and whether the current
 * user has an onboarding request (gates the My Onboarding link).
 *
 * Shared by the desktop sidebar and the m.idarah.io landing grid so both
 * render identical dynamic items without duplicating fetches.
 */
export const useNavigationExtras = () => {
  const [desks, setDesks] = useState<any[]>([]);
  // Whether the current user has an onboarding request — gates the
  // My Onboarding menu item (hidden for existing employees without one).
  const [hasOnboarding, setHasOnboarding] = useState(false);

  useEffect(() => {
    const fetchDesks = async () => {
      try {
        const response = await api.get('/api/service-desk');
        if (response.success) {
          setDesks(response.desks);
        }
      } catch (error) {
        console.error("Error fetching navigation desks:", error);
      }
    };
    fetchDesks();

    // Listen for changes in service desks (from settings)
    window.addEventListener('service-desks-changed', fetchDesks);
    return () => window.removeEventListener('service-desks-changed', fetchDesks);
  }, []);

  useEffect(() => {
    const checkOnboarding = async () => {
      try {
        const res = await api.get<{ success: boolean; has: boolean }>(
          '/api/onboarding/my-portal/exists',
          { skipErrorToast: true }
        );
        if (res.success) {
          setHasOnboarding(res.has);
        }
      } catch (error) {
        console.error("Error checking onboarding:", error);
      }
    };
    checkOnboarding();
  }, []);

  return {
    activeDesks: desks.filter(d => !d.isRetired),
    retiredDesks: desks.filter(d => d.isRetired),
    hasOnboarding,
  };
};
